import { useEffect, useState } from "react";
import styles from "./upload_status.module.css";
import { useSelector, useDispatch } from "react-redux";
import { handleFileUpload, cancelRequests } from "./helpers";
import { updatePercentage, cancelUploads } from "redux/files/actions";
import axios from "axios";
import { post } from "util/requests";
import { corelab_api_url } from "config";
const worker = new Worker(new URL("./upload_worker.js", import.meta.url));
export default function UploadStatus(props) {
  const { subject_id } = props;
  const files = useSelector((state) => state.files.files);
  const active_study_id = useSelector((state) => state.study.active_study_id);
  const dispatch = useDispatch();

  const [showing, setShowing] = useState(false);
  const [sourceToken, setSourceToken] = useState(null);

  const setProgress = (filename, percentage) => {
    dispatch(updatePercentage(filename, percentage));
  };

  useEffect(() => {
    if (files.length) {
      setShowing(true);
      let should_trigger_file = !files.find((f) => f.uploading) && files.find((f) => f.percentage === 0);
      // if (files[0].percentage === 0 && !files[0].uploading) {
      if (should_trigger_file) {
        // const source = axios.CancelToken.source();
        // setSourceToken(source);
        handleFileUpload(
          dispatch,
          global.files[should_trigger_file.name],
          setProgress,
          subject_id,
          worker,
          active_study_id
        );
      }
    }
  }, [files]);

  const show_close = () => {
    return files.filter((f) => f.percentage !== 100).length === 0;
  };

  if (!showing) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        {show_close() ? (
          <div className={styles.title}>Uploading complete</div>
        ) : (
          <div className={styles.title}>
            Uploading {files.length} item{files.length === 1 ? "" : "s"}
          </div>
        )}
        {show_close() ? (
          <div className={styles.cancel} onClick={() => setShowing(false)}>
            close
          </div>
        ) : (
          <div
            className={styles.cancel}
            onClick={() => {
              // if (sourceToken) {
              //   sourceToken.cancel();
              //   setSourceToken(null);
              // }
              cancelRequests(worker);
              dispatch(cancelUploads());
              // post(`${corelab_api_url}/cancel_upload`, {
              //   files: files
              //     .filter((f) => f.percentage !== 100)
              //     .map((f) => ({ name: f.name })),
              // });
              setShowing(false);
            }}
          >
            cancel
          </div>
        )}
      </div>
      <div className={styles.rows}>
        {files.map((file) => (
          <div className={styles.row} key={file.name}>
            <div className={styles.name}>{file.name}</div>
            <div className={styles.percentage}>{Math.floor(file.percentage)}%</div>
          </div>
        ))}
      </div>
    </div>
  );
}
